import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { ApiServicesService } from '../services/api-services.service';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {

  private isEditSubject = new BehaviorSubject<string>('');
  isEdit$ = this.isEditSubject.asObservable();
  public isViewSubject = new BehaviorSubject<string>('');
  isView$ = this.isViewSubject.asObservable();
  formval: any;
  limit=10;
  page = 1;


  constructor(private apiservices: ApiServicesService) { }

  close_task(newValue: string) {
    this.isEditSubject.next(newValue);
  }

  private drawerSubject = new Subject<any>();
  isDrawer$ = this.drawerSubject.asObservable();


  public changeFriendsTab = new BehaviorSubject<any>('');
  changeFriendsTab$ = this.changeFriendsTab.asObservable();

  toggleDrawer(val:any) {
    this.drawerSubject.next(val);
    // console.log('nnnnnnnnnnnn')
  }

  changefriTab(value:any){
    this.changeFriendsTab.next(value)
  }

  changefriTabrevert(){
    this.changeFriendsTab.next('')
  }

  public isSearchdata = new BehaviorSubject<any>('');
  searchdata$ = this.isSearchdata.asObservable();


  setSearchdata(searchresponce: any) {
    this.isSearchdata.next(searchresponce)
  }


  clearSearchdata() {
    this.isSearchdata.next(null)
  }

}
